import { NextSeo } from "next-seo";
import Head from "next/head";
import React from "react";
import { breadcrumbsJson } from "./breadcrumbs-seo";

type SCHEMA_ORG_PROPS = {
  author: {
    name: string;
  };
  canonicalUrl: string;
  datePublished: string;
  dateModified: string;
  defaultTitle: string;
  description: string;
  image: string;
  organization: {
    url: string;
    logo: string;
    name: string;
  };
  title: string;
  url: string;
};

const BlogPostSEO = React.memo<SCHEMA_ORG_PROPS>(
  ({
    author,
    canonicalUrl,
    datePublished,
    dateModified,
    defaultTitle,
    description,
    image,
    organization,
    title,
    url,
  }) => {
    const baseSchema = [
      {
        "@context": "http://schema.org",
        "@type": "WebSite",
        url,
        name: title,
        alternateName: defaultTitle,
      },
    ];

    const schema = [
      ...baseSchema,
      breadcrumbsJson(url),
      {
        "@context": "http://schema.org",
        "@type": "BlogPosting",
        url,
        name: title,
        alternateName: defaultTitle,
        headline: title,
        image: {
          "@type": "ImageObject",
          url: image,
        },
        description,
        author: {
          "@type": "Person",
          name: author.name,
        },
        publisher: {
          "@type": "Organization",
          url: organization.url,
          logo: organization.logo,
          name: organization.name,
        },
        mainEntityOfPage: {
          "@type": "WebSite",
          "@id": canonicalUrl,
        },
        datePublished,
      },
    ];

    return (
      <>
        <NextSeo title={title} />
        <Head>
          {/* Schema.org tags */}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        </Head>
      </>
    );
  }
);

export { BlogPostSEO };
